import { Props } from "wasabi-common";

type Callback = (...args: any[]) => void;

export interface CallbackWithPeriod {
  period: number;
  handler: Handler;
}

type Handler = Callback | CallbackWithPeriod;

export interface HandlerTimerProps {
  handleTime?: number;
  handlers?: Props<Handler>;
}

export class HandlerTimer {
  private static readonly ONE_SECOND = 1000;
  public static readonly ONE_MINUTE = 60;
  private props: HandlerTimerProps;
  private _isInProgress = false;
  private timer: any;
  private timerCount = 0;

  public constructor(props?: HandlerTimerProps) {
    this.props = props || {};
    this.props.handleTime = this.props.handleTime || HandlerTimer.ONE_MINUTE;
    this.props.handlers = this.props.handlers || {};
    this.callHandlers = this.callHandlers.bind(this);
    this.props = props;
  }

  public start() {
    if (!this.isInProgress) {
      this.timer = setInterval(this.callHandlers, this.props.handleTime * HandlerTimer.ONE_SECOND);
      this._isInProgress = true;
    }
  }

  private callHandlers() {
    this.timerCount += 1;
    for (const key in this.props.handlers) {
      if (this.props.handlers.hasOwnProperty(key)) {
        const handler: Handler = this.props.handlers[key];
        if (typeof handler !== "function") {
          if (this.timerCount % handler.period === 0) {
            // @ts-ignore
            setTimeout(handler.handler, 0);
          }
        } else {
          setTimeout(handler, 0);
        }
      }
    }
  }

  public get isInProgress() {
    return this._isInProgress;
  }

  public stop() {
    if (this.isInProgress) {
      clearInterval(this.timer);
      this._isInProgress = false;
    }
  }

  public add(key: string, handler: Handler) {
    if (typeof handler === "function") {
    }
    this.props.handlers[key] = handler;
  }

  public remove(key: string) {
    delete this.props.handlers[key];
  }
}
